import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { Layout } from '@/components/Layout';
import LinkWrapper from '@/components/LinkWrapper';
import Page from '@/components/Page';
import replaceAbbreviations from '@/utilities/replaceAbbreviations';

interface CmsSitemapItem {
  title: string;
  path: string;
  children?: CmsSitemapItem[];
}

function SitemapItem({ item }: { item: CmsSitemapItem }) {
  const hasChildren = Array.isArray(item.children) && item.children.length > 0;
  return (
    <li className="SitemapItem">
      <LinkWrapper href={item.path ? item.path : '#'} tabIndex={0}>
        <span dangerouslySetInnerHTML={replaceAbbreviations(item.title)} />
      </LinkWrapper>
      {hasChildren && (
        <ul className="SitemapItem__list">
          {item.children?.map((child, i) => (
            <SitemapItem key={i} item={child} />
          ))}
        </ul>
      )}
    </li>
  );
}

export default class PageSitemap extends Page<{
  title: string;
  path: string;
}> {
  render() {
    const { title, path, sitemap } = this.props;
    return (
      <>
        <Header />
        <main className="page page--default">
          <Layout path={path}>
            <h1 className="Layout__title">{title}</h1>
            <nav className="Sitemap Richtext">
              <ul className="Sitemap__list">
                {sitemap.map((item, i) => (
                  <SitemapItem key={i} item={item} />
                ))}
              </ul>
            </nav>
          </Layout>
          <Footer />
        </main>
      </>
    );
  }
}

// Not named `getStaticProps` directly: Turbopack's app-router `sitemap`
// metadata-route convention incorrectly matches this pages-router file by its
// basename, breaking the build. https://github.com/vercel/next.js/issues/96966
async function loadSitemapProps() {
  return {
    props: {
      path: '/sitemap',
      description:
        'Eine Übersicht aller Seiten und Inhalte von LOTTO.de finden Sie in der Sitemap der Webseite. ',
      title: 'Sitemap',
      sitemap: [
        {
          title: 'LOTTO.de - Spielen beim Original!',
          path: '/',
        },
        {
          title: 'LOTTO 6aus49 - Lotterie-Übersicht',
          path: '/lotto-6aus49',
          children: [
            {
              title: 'LOTTO spielen',
              path: '/lotto-6aus49/spielen',
            },
            {
              title: 'Aktuelle Lottozahlen und Lottoquoten',
              path: '/lotto-6aus49/lottozahlen',
            },
            {
              title: 'LOTTO 6aus49 Statistik',
              children: [
                {
                  title: 'LOTTO 6aus49 Ziehungshäufigkeit | Statistik',
                  path: '/lotto-6aus49/statistik/ziehungshaeufigkeit',
                },
                {
                  title: 'LOTTO 6aus49 Barometer | Statistik',
                  path: '/lotto-6aus49/statistik/barometer',
                },
                {
                  title: 'LOTTO 6aus49 Histogramm | Statistik',
                  path: '/lotto-6aus49/statistik/histogramm',
                },
              ],
            },
            {
              title: 'LOTTO 6aus49 Spielregeln',
              path: '/lotto-6aus49/spielregeln',
            },
            {
              title: 'LOTTO 6aus49 Informationen',
              children: [
                {
                  title: 'Neuer Gewinnplan bei LOTTO 6aus49',
                  path: '/lotto-6aus49/info/gewinnplanaenderung',
                },
                {
                  title: 'LOTTO 6aus49 Online-Annahmeschluss',
                  path: '/lotto-6aus49/info/annahmeschluss',
                },
                {
                  title: 'LOTTO 6aus49 Gewinnwahrscheinlichkeit',
                  path: '/lotto-6aus49/info/gewinnwahrscheinlichkeit',
                },
                {
                  title: 'LOTTO 6aus49 Maximal-Jackpot',
                  path: '/lotto-6aus49/info/maximal-jackpot',
                },
                {
                  title: 'LOTTO mit System online spielen',
                  path: '/lotto-6aus49/info/lotto-mit-system-vollsysteme-teilsysteme',
                },
                {
                  title: 'LOTTO 6aus49 Sonderauslosungen',
                  path: '/lotto-6aus49/info/sonderauslosungen',
                },
                {
                  title: 'LOTTO-Spielgemeinschaften',
                  path: '/lotto-6aus49/info/lotto-spielgemeinschaften-tippgemeinschaften',
                },
              ],
            },
            {
              title: ' LOTTO 6aus49: Live-Ziehung der Lottozahlen',
              path: '/lotto-6aus49/lotto-ziehung',
            },
            {
              title: 'Alles zu LOTTO 6aus49',
              children: [
                {
                  title: 'LOTTO-Studio in Saarbrücken',
                  path: '/lotto-6aus49/ueber/lotto-studio',
                },
                {
                  title: 'LOTTO-Studio: Ziehungsabläufe',
                  path: '/lotto-6aus49/ueber/ziehungsablaeufe',
                },
                {
                  title: 'Fakten rund um die Lottokugeln',
                  path: '/lotto-6aus49/ueber/lotto-kugeln',
                },
                {
                  title: 'LOTTO-Studio: Ziehungsgeräte und Ausstattung',
                  path: '/lotto-6aus49/ueber/ausstattung',
                },
                {
                  title: 'LOTTO-Studio: Moderation der Ziehung',
                  path: '/lotto-6aus49/ueber/moderation',
                },
                {
                  title: 'LOTTO 6aus49: Zeitreise durch die LOTTO-Historie',
                  path: '/lotto-6aus49/ueber/historie',
                },
              ],
            },
            {
              title: 'Spiel 77 & SUPER 6',
              children: [
                {
                  title: 'Spiel 77 & SUPER 6: Spielregeln',
                  path: '/lotto-6aus49/spiel77-super6/spielregeln',
                },
                {
                  title: 'Spiel 77 & SUPER 6: Zahlen & Quoten',
                  path: '/lotto-6aus49/spiel77-super6/zahlen',
                },
                {
                  title: 'Spiel 77 & SUPER 6: Gewinnwahrscheinlichkeit',
                  path: '/lotto-6aus49/spiel77-super6/gewinnwahrscheinlichkeit',
                },
                {
                  title: 'Spiel 77: Maximal-Jackpot',
                  path: '/lotto-6aus49/spiel77-super6/maximal-jackpot',
                },
                {
                  title: 'Spiel 77-Sonderauslosungen',
                  path: '/lotto-6aus49/spiel77-super6/sonderauslosungen',
                },
              ],
            },
          ],
        },
        {
          title: 'Eurojackpot | Eurolotto - Lotterie-Übersicht',
          path: '/eurojackpot',
          children: [
            {
              title: 'Eurojackpot spielen | Eurolotto',
              path: '/eurojackpot/spielen',
            },
            {
              title: 'Eurojackpot Zahlen und Quoten',
              path: '/eurojackpot/zahlen',
            },
            {
              title: 'Eurojackpot-Ziehung',
              path: '/eurojackpot/ziehung',
            },
            {
              title: 'Eurojackpot Spielregeln',
              path: '/eurojackpot/spielregeln',
            },
            {
              title: 'Eurojackpot Informationen',
              children: [
                {
                  title: 'Eurojackpot-Produktänderung ab 25. März 2022',
                  path: '/eurojackpot/produktaenderung-2022',
                },
                {
                  title: 'Eurojackpot Online-Annahmeschluss',
                  path: '/eurojackpot/annahmeschluss',
                },
                {
                  title: 'Eurojackpot Gewinnwahrscheinlichkeit',
                  path: '/eurojackpot/gewinnwahrscheinlichkeit',
                },
                {
                  title: 'Eurojackpot mit System online spielen',
                  path: '/eurojackpot/eurojackpot-system',
                },
                {
                  title: 'Eurojackpot-Höchstgewinne',
                  path: '/eurojackpot/hoechstgewinne',
                },
              ],
            },
          ],
        },
        {
          title: 'GlücksSpirale - Lotterie-Übersicht',
          path: '/gluecksspirale',
          children: [
            {
              title: 'GlücksSpirale spielen',
              path: '/gluecksspirale/spielen',
            },
            {
              title: 'GlücksSpirale Gewinnzahlen und Quoten',
              path: '/gluecksspirale/gewinnzahlen',
            },
            {
              title: 'GlücksSpirale Spielregeln',
              path: '/gluecksspirale/spielregeln',
            },
            {
              title: 'GlücksSpirale Informationen',
              children: [
                {
                  title: 'GlücksSpirale-Gewinnplanänderung 2025',
                  path: '/gluecksspirale/info/gewinnplanaenderung-2025',
                },
                {
                  title: 'GlücksSpirale Online-Annahmeschluss',
                  path: '/gluecksspirale/info/annahmeschluss',
                },
                {
                  title: 'GlücksSpirale Gewinnwahrscheinlichkeit',
                  path: '/gluecksspirale/info/gewinnwahrscheinlichkeit',
                },
                {
                  title: 'GlücksSpirale Sonderauslosungen',
                  path: '/gluecksspirale/info/sonderauslosungen',
                },
                {
                  title: '„Sieger-Chance“ der GlücksSpirale',
                  path: '/gluecksspirale/info/sieger-chance',
                },
                {
                  title: 'GlücksSpirale-Jahreslos',
                  path: '/gluecksspirale/info/jahreslos',
                },
              ],
            },
          ],
        },
        {
          title: 'KENO - Lotterie-Übersicht',
          path: '/keno',
          children: [
            {
              title: 'KENO spielen',
              path: '/keno/spielen',
            },
            {
              title: 'KENO Zahlen und Quoten',
              path: '/keno/zahlen',
            },
            {
              title: 'KENO-Ziehung',
              path: '/keno/ziehung',
            },
            {
              title: 'KENO Spielregeln',
              path: '/keno/spielregeln',
            },
            {
              title: 'KENO Informationen',
              children: [
                {
                  title: 'KENO Online-Annahmeschluss',
                  path: '/keno/info/annahmeschluss',
                },
                {
                  title: 'KENO Gewinnwahrscheinlichkeit',
                  path: '/keno/info/gewinnwahrscheinlichkeit',
                },
                {
                  title: 'KENO Zusatzauslosungen',
                  path: '/keno/info/zusatzauslosungen',
                },
              ],
            },
          ],
        },
        {
          title: 'Rubbellose - Das Glück für zwischendurch',
          path: '/rubbellose',
          children: [
            {
              title: 'Rubbellose | Sofortlotterien',
              path: '/rubbellose/informationen',
            },
            {
              title: 'Rubbellos Goldene 7 (9. Auflage)',
              path: '/rubbellose/rubbellos-goldene-7',
            },
            {
              title: 'Rubbellos Platin 7 (10. Auflage)',
              path: '/rubbellose/rubbellos-platin-7',
            },
            {
              title: 'Rubbellos Diamant 7 (3. Auflage)',
              path: '/rubbellose/rubbellos-diamant-7',
            },
            {
              title: 'Rubbellos X50 (2. Auflage)',
              path: '/rubbellose/rubbellos-x50',
            },
            {
              title: 'Rubbellos X20 (1. Auflage)',
              path: '/rubbellose/rubbellos-x20',
            },
          ],
        },
        {
          title: 'Über LOTTO.de',
          path: '/ueber',
          children: [
            {
              title: 'Mein LOTTO',
              path: '/ueber/mein-lotto',
            },
            {
              title: 'Neuigkeiten - Pressemeldungen',
              path: '/ueber/neuigkeiten',
            },
            {
              title: 'Häufige Fragen zu LOTTO.de',
              path: '/ueber/faq',
            },
            {
              title: 'Kundenservice der Landes­lotterie­gesellschaften',
              path: '/ueber/kundenservice',
            },
            {
              title: 'Glücksspielstaatsvertrag 2021',
              path: '/ueber/gluecksspielstaatsvertrag',
              children: [
                {
                  title: 'Sind die „Zweitlotterie“-Angebote seriös?',
                  path: '/ueber/gluecksspielstaatsvertrag/zweitlotterien',
                },
                {
                  title:
                    'Checkliste: Wie erkenne ich seriöse Lotterie-Anbieter?',
                  path: '/ueber/gluecksspielstaatsvertrag/checkliste-serioese-lotto-anbieter',
                },
                {
                  title:
                    'Lotterien im Ausland: Powerball, Euromillions, El Gordo, Cash4Life, Mega Millions',
                  path: '/ueber/gluecksspielstaatsvertrag/lotterien-im-ausland',
                },
              ],
            },
            {
              title: 'TOTO – Die Fußballwette mit Jackpot ⚽',
              path: '/ueber/toto-fussballwette',
              children: [
                {
                  title: 'Ergebniswette Gewinnzahlen und Quoten',
                  path: '/ueber/toto-fussballwette/toto-ergebniswette-gewinnzahlen-und-quoten',
                },
                {
                  title: 'Auswahlwette Gewinnzahlen und Quoten',
                  path: '/ueber/toto-fussballwette/toto-auswahlwette-gewinnzahlen-und-quoten',
                },
                {
                  title: 'Spielergebnisse TOTO Ergebniswette',
                  path: '/ueber/toto-fussballwette/toto-ergebniswette-spielergebnisse',
                },
                {
                  title: 'Spielergebnisse TOTO Auswahlwette',
                  path: '/ueber/toto-fussballwette/toto-auswahlwette-spielergebnisse',
                },
              ],
            },
            {
              title: 'Deutscher Lotto- und Totoblock (DLTB)',
              path: '/ueber/deutscher-lotto-und-totoblock',
            },
            {
              title: 'Testsiege und Auszeichnungen für LOTTO.de 🏆',
              path: '/ueber/tests-und-auszeichnungen',
            },
          ],
        },
        {
          title: 'Impressum',
          path: '/impressum',
        },
        {
          title: 'Datenschutzerklärung nach der DS-GVO',
          path: '/datenschutzerklaerung',
        },
        {
          title: 'Barrierefreiheit',
          path: '/erklaerung-zur-barrierefreiheit',
        },
        {
          title: 'Welche Lotterie hat die besten Gewinnchancen?',
          path: '/lotterienvergleich',
        },
        {
          title: 'Wie bezahle ich beim Online-LOTTO?',
          path: '/wie-bezahle-ich-beim-online-lotto',
        },
        {
          title: 'Verwendung der Lotterieeinnahmen',
          path: '/verwendung-der-lotterieeinnahmen',
        },
        {
          title: 'LOTTO.de als Partner von Bonusprogrammen',
          path: '/cashback',
        },
        {
          title: 'Aktuelle Jackpots: LOTTO 6aus49 & Eurojackpot',
          path: '/aktuelle-jackpots',
        },
        {
          title: 'Silvester- und Neujahrs-Lotterien in Deutschland',
          path: '/silvester-und-neujahrs-lotterien',
        },
        {
          title: 'LOTTO-Annahmestellen / Verkaufsstellen',
          path: '/lotto-annahmestellen',
        },
        {
          title: 'LOTTO-Gewinnprüfung / Online-Gewinnabfrage',
          path: '/lotto-gewinnpruefung-gewinnabfrage',
        },
        {
          title: 'LOTTO-Apps der Landeslotteriegesellschaften',
          path: '/lotto-apps',
        },
        {
          title: 'LOTTO-Cards / Kundenkarten',
          path: '/lotto-card-kundenkarten',
        },
        {
          title: 'Online-Glücksspiele',
          path: '/online-gluecksspiele',
        },
        {
          title: 'Vulnerability Disclosure Policy (VDP)',
          path: 'https://vdp.lotto.de/p/Policy',
        },
      ],
    },
  };
}

export { loadSitemapProps as getStaticProps };
